import React from 'react';
import styled from 'styled-components';

import Tag from 'antd/lib/tag';
import Popover from 'antd/lib/popover';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

import copyToClipboard from '../../helpers/copyToClipboard';
import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import { renderCurrency } from '../../components/SystemCountry';

import {
  getLinkWithSearchFields,
} from '../../components/Links';
import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

const Code = styled(Tag)`
  cursor: pointer;
`;

const NameAndCode = ({ name, code, link }) => (
  <span>
    <Link to={link}>
      {name}
    </Link>
    <span>&nbsp;/&nbsp;</span>
    <Code onClick={() => copyToClipboard(code, 'Code copied to clipboard!')}>
      {code}
    </Code>
  </span>
);

export const columnNameAdmin = {
  path: 'code',
  render: record => (
    <NameAndCode
      name={record.name}
      code={record.code}
      link={`/discountcodes/${record._id}`}
    />
  ),
};

export const columnNameSeller = {
  path: 'code',
  render: record => (
    <NameAndCode
      name={record.name}
      code={record.code}
      link={`/store/discountcodes/${record._id}`}
    />
  ),
};

export const columnStore = {
  title: 'Store',
  path: 'store.name',
  link: '/stores/:store._id',
};

// export const columnCode = {
//   title: 'Code',
//   path: 'code',
//   render: record => (
//     <Code
//       onClick={() => copyToClipboard(record.code, 'Code copied to clipboard!')}
//     >
//       {record.code}
//     </Code>
//   ),
// };

export const columnActive = {
  path: 'active',
  title: 'Status',
  render: record => (record.active ? 'ACTIVE' : 'INACTIVE'),
};

export const columnAmount = {
  path: 'amount',
  title: 'Amount',
  render: record => (
    <span>
      {
        (
             !record.amountFull
          && !record.amountShippingAndPaymentFull
          && !record.amountFixed
          && !record.amountPercentage
        )
        ? '-'
        : null
      }
      {
        record.amountFull
        ? 'Items: Free'
        : (
            <>
              {
                record.amountFixed > 0 || record.amountPercentage > 0
                ? 'Items: '
                : null
              }
              {
                record.amountPercentage > 0
                ? `-${record.amountPercentage}%`
                : null
              }
              {
                record.amountFixed > 0
                ? (
                    <>
                      {`${record.amountPercentage > 0 ? ' ' : ''}`}
                      {
                        renderCurrency({
                          prefix: `-${record.amountFixed} `,
                        })
                      }
                    </>
                  )
                : null
              }
            </>
          )
      }
      {
        record.amountShippingAndPaymentFull
        ? ' / Delivery: Free'
        : null
      }
    </span>
  ),
};

export const columnUsage = {
  path: 'usage',
  title: 'Usage',
  sort: 'usage',
  render: (record, column, props) => {
    const link = getLinkWithSearchFields(
      props.location,
      [{ name: 'discountcode', value: record._id }],
      { pathname: getRoleBasedPath(props, '/orders') },
    );
    const label = `${
      record.usage || 0
    } / ${
      record.usageMax > 0 ? record.usageMax : 'Unlimited'
    }`;
    return (
      <Popover
        title={null}
        content={(
          <div>
            <span>Show orders with </span>
            <Link to={link}>
              this discount code
            </Link>
          </div>
        )}
      >
        <Link to={link}>
          {label}
        </Link>
      </Popover>
    );
  },
};

export const ADMIN = [
  columnNameAdmin,
  columnStore,
  // columnCode,
  columnActive,
  columnAmount,
  columnUsage,
  // columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];

export const SELLER = [
  columnNameSeller,
  // columnCode,
  columnActive,
  columnAmount,
  columnUsage,
  // columnProducts,
  columnCreatedAt,
  columnUpdatedAt,
];
